/* eslint-disable import/no-unresolved */
/* eslint-disable react/no-array-index-key */
import React from 'react'
import { RutgersTab, RutgersTabs } from '../Tabs/RutgersTabs'
import { TabPanel } from '../TabPanel/TabPanel'
import LinkList from '../LinkList/LinkList'

function TabLinkList({ tabs, ariaLabel, dispatch, widgetId, classes }) {
  const [value, setValue] = React.useState(0)

  const handleChange = (event, newValue) => {
    setValue(newValue)
  }
  return (
    <>
      <RutgersTabs value={value} onChange={handleChange} aria-label={ariaLabel}>
        {tabs?.map((tab, index) => (
          <RutgersTab label={tab.title} key={index} />
        ))}
      </RutgersTabs>
      {tabs?.map((tab, index) => (
        <TabPanel key={tab} value={index} index={index}>
          {value === index && (
            <div className={classes.linkListContainer}>
              <LinkList
                links={tab.iconLinks}
                widgetId={widgetId}
                dispatch={dispatch}
              />
            </div>
          )}
        </TabPanel>
      ))}
    </>
  )
}

export default TabLinkList
